export default __webpack_public_path__ + "static/media/axeleratum-white-logo.1151e655.svg";